import { render } from "./PaymentSelection.vue?vue&type=template&id=b7885f84&scoped=true"
import script from "./PaymentSelection.vue?vue&type=script&lang=js"
export * from "./PaymentSelection.vue?vue&type=script&lang=js"

import "./PaymentSelection.vue?vue&type=style&index=0&id=b7885f84&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7885f84"]])

export default __exports__